'use strict';

angular.module('atex.dam').controller('DamSearchController', ['$scope', '$q', 'DamSearchService', 'DamFoldersService', '$window', 'UIConfigurationService', '$rootScope', 'configuration',
  function($scope, $q, DamSearchService, DamFoldersService, $window, UIConfigurationService, $rootScope, configuration) {
    $scope.tabSelected = "production";
    $scope.tabQueries = [];
    $scope.querytabModels = [];

    $scope.partitionConfigurations = [];
    $scope.partitionConfigurations["production"] = {
      "id": "production",
      "label": "__PRODUCTION_PARTITION__",
      "icon": "fa fa-globe",
      "icon-color": "black"
    };
    $scope.partitionConfigurations["incoming"] = {
      "id": "incoming",
      "label": "__INCOMING_PARTITION__",

      "icon": "fa fa-rss",
      "icon-color":"blue"
    };

    $scope.partitionConfigurations["archive"] = {
      "id": "archive",
      "label": "__ARCHIVE_PARTITION__",

      "icon": "fa fa-archive",
      "icon-color":"green"
    };

    function info(selectedTab) {
      return {
        name: "search-form",
        id: "desk-search-form",
        profile: "search-forms",
        selectedTab: selectedTab
      };
    }

    function extractQuery(queryModel, selectedTab) {
      if (queryModel.fullText || queryModel.fields) {
        queryModel.set = {};
        queryModel.operators = {};
      }

      if (queryModel.fullText) {
        queryModel.set['atex_desk_text'] = queryModel.fullText;
      }

      if (queryModel.fields) {
        var fields = atex.onecms.ObjectUtils.getByPath(queryModel, "fields") || [];
        fields.forEach(function (field) {
          if (field.type === 'DATE') {
            if (field.disablePatchDate === true){
              atex.dam.ViewUtils.patchDateIntervalFullRange(field.values);
            }else{
              atex.dam.ViewUtils.patchDateInterval(field.values);
            }
          }
        });

        return UIConfigurationService.configuration(info().name, info().id, 'atex_desk_objectType', info().profile, selectedTab).then(function (configuration) {
          var type = _.find(fields, function (field) {
            return field.key === "atex_desk_objectType";
          });

          var _type = atex.onecms.ObjectUtils.getByPath(type, "values") || [];
          var _conf = atex.onecms.ObjectUtils.getByPath(configuration, "fields") || [];

          if (_type.length >= _conf.length) {
            queryModel.fields = _.without(queryModel.fields, _.findWhere(queryModel.fields, {
              key: 'atex_desk_objectType'
            }));
          }

          var promises = queryModel.fields.map(function (field) {
            return UIConfigurationService.draw(field, info().name, info().id, info().profile, selectedTab).then(function (values) {
              queryModel.set[field.key] = values;
              queryModel.operators[field.key] = field.operator;
            });
          });

          return $q.all(promises).then(function () {
            delete queryModel.fields;
            return queryModel;
          });
        });
      } else {
        return $q.when(queryModel);
      }
    }

    $scope.query = DamSearchService.getCurrentAdvQuery();

    $scope.initFirstTab = function () {
      if ($("#production-tab")[0] !== undefined && $("#searchvalueinput").val() !== '' && $rootScope.lastSearchValueInput !==  $("#searchvalueinput").val()){
        $rootScope.lastSearchValueInput =  $("#searchvalueinput").val();
        $scope.setSelectedTab($scope.tabSelected);
      }
      var tabStyle = 'min-height: 620px;overflow-y: auto; max-height: 88%;';

      if ($('.dam-adv-search-popover').length > 0 && !$('.dam-adv-search-popover').attr('style').includes(tabStyle)){
        var windowWidth = $(window).width();
        switch (true) {
          case (windowWidth < 600):
            tabStyle += tabStyle + "max-width: 200px !important;width: 200px !important;";
            break;
          case (windowWidth < 700):
            tabStyle += tabStyle + "max-width: 400px !important;width: 400px !important;";
            break;
          case (windowWidth < 1200):
            tabStyle += tabStyle + "max-width: 500px !important;width: 500px !important;";
            break;
          case (windowWidth < 1400):
            tabStyle += tabStyle + "max-width: 600px !important;width: 600px !important;";
            break;
          case (windowWidth < 1600):
            tabStyle += tabStyle + "max-width: 700px !important;width: 700px !important;";
            break;
          case (windowWidth < 1800):
            tabStyle += tabStyle + "max-width: 800px !important;width: 800px !important;";
            break;
          case (windowWidth >= 1800):
            tabStyle += tabStyle + "max-width: 900px !important;width: 900px !important;";
            break;
          default:
            tabStyle += tabStyle + "max-width: 300px !important;width: 300px !important;";
        }

        $('.dam-adv-search-popover').attr('style', $('.dam-adv-search-popover').attr('style') + ' ' + tabStyle);
      }

    };

    $scope.$on("dam:clearAdvancedFields",function(event,tab,set) {
      $scope.query.set = {};
      if (tab){
        if (set &&  $scope.querytabModels[tab]){
          $scope.querytabModels[tab].set = set;
        }
        $scope.setSelectedTab(tab,true);
      }
    });

    $rootScope.$on("uiSearchForm:changed",function(event, model) {
      if ($scope.queryModel !== model){
        $scope.querytabModels[model.tab] = model;
      }
    });

    $rootScope.$on("dam:queryListSearch",function(event, model) {
      $scope.query = DamSearchService.getCurrentAdvQuery();
    });

    $rootScope.$on("dam:resetList",function(event, model) {
      $scope.querytabModels = [];
    });


    $scope.setSelectedTab = function (tabId, doNotTakeFromCurrentAdv) {
      var query = $scope.querytabModels[$scope.tabSelected];
      if (query === undefined){
        query = DamSearchService.getCurrentAdvQuery();
      }
      if (doNotTakeFromCurrentAdv){
        query.fullText = "";
        query.fields = [];
      }
      extractQuery(angular.copy(query), tabId).then(function (q) {
        $scope.tabQueries[$scope.tabSelected] = q;
        $scope.tabSelected = tabId;

        if ($scope.tabQueries[$scope.tabSelected]) {
          $scope.query = $scope.tabQueries[$scope.tabSelected];
          $scope.query.tab = tabId;
          if ($scope.query.set === undefined){
            $scope.query.set = {};
          }
          $scope.query.set["tag_dimension.partition_ss"] = [$scope.partitionConfigurations[tabId]];
          if ($scope.query.set["atex_desk_text"] === undefined){
            $scope.query.set["atex_desk_text"] = $rootScope.lastSearchValueInput;
          }
        } else {
          $scope.query = {
            tab:tabId,
            set: {
              "tag_dimension.partition_ss": [$scope.partitionConfigurations[tabId]]
            }
          };
          $scope.query.set["atex_desk_text"] = $rootScope.lastSearchValueInput;
        }
      });
    };

    configuration.getDefaultSelectionTabSearch().then(function (value) {
      if (value) {
        $scope.query = value;
      }
      $scope.query.tab = $scope.tabSelected;
      $scope.query.set["tag_dimension.partition_ss"] = [$scope.partitionConfigurations[$scope.tabSelected]];
    });

    // advanced search
    $scope.full = function(query) {
      query.hiddenQuery = false;
      $window.atex.analytics('event', { e: 'advancedQuery', d1: $scope.getQueryParams(query.fields)});
      // Check double fulltext
      if (query && query.fields) {
        var found = query.fields.find(function (field) {
          return field.key === 'atex_desk_text';
        });
        if (found && found.values[0]) {
          query.fullText = undefined;
        }
      }

      if (query.fields) {
        query.fields.forEach(function(field){
          if (field.type === 'DATE') {
            if (field.disablePatchDate === true){
              atex.dam.ViewUtils.patchDateIntervalFullRange(field.values);
            }else{
              atex.dam.ViewUtils.patchDateInterval(field.values);
            }
          }
        });
      }

      var ts = Date.now();
      DamSearchService.setLastQueryStartTs(ts);
      if (DamFoldersService.listingFolder) {
        DamFoldersService.executeQuery(DamFoldersService.listingFolder, query);
      } else {
        var extraInfo = {
          queryTs: ts,
          viewMode:query.viewMode,
          type:query._type
        };
        DamSearchService.advancedSearch(query, extraInfo);
      }
    };

    $scope.getQueryParams= function(items) {
      var arr = [];
      if (items && items.length > 0) {
        items.forEach(function (item) {
          if(item.values && item.values.length > 0) {
            item.values.forEach(function (value) {
              arr.push(value);
            });
          }
        });
      }
      return arr;
    };
  }]);
